import styled from 'styled-components';
import breakpoint from 'components/utils/responsive';
import { colorToken } from "components/utils/constants";

export default styled.div`
    min-height: 100vh;
    display: flex;
    padding-top: 115px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: url('/assets/img/bg-interna.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    img {
        max-width: 100%;
    }
    @media ${breakpoint.md} {
        padding-top: 124px;
        /* flex-basis: 50%;
        flex-direction: row; */
    }

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12pt;
      line-height: 1.6;
      color: #1a1a1a;
      background: #f5f5f5;
    }

    .page {
      max-width: 820px;
      margin: 32px auto;
      background: #fff;
      padding: 60px 72px;
      box-shadow: 0 2px 12px rgba(0,0,0,.12);
    }

    /* Header */
    .doc-header {
      text-align: center;
      margin-bottom: 32px;
    }
    .doc-header img {
      width: 90px;
      margin-bottom: 16px;
    }
    .doc-header h1 {
      font-size: 13pt;
      font-weight: bold;
      letter-spacing: .5px;
      margin-bottom: 4px;
    }
    .doc-header h2 {
      font-size: 13pt;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .doc-header .cert {
      font-size: 11pt;
      font-weight: bold;
    }

    /* Section titles */
    h3.section-title {
      font-size: 12pt;
      font-weight: bold;
      margin: 28px 0 10px;
      text-transform: uppercase;
      border-bottom: 1px solid #ccc;
      padding-bottom: 4px;
    }

    /* Numbered block headings */
    .block-heading {
      font-weight: bold;
      margin: 20px 0 6px;
    }

    p {
      margin-bottom: 8px;
    }

    ol, ul {
      margin: 6px 0 10px 24px;
    }
    li {
      margin-bottom: 4px;
    }

    /* Prizes table */
    table {
      width: 100%;
      border-collapse: collapse;
      margin: 16px 0;
      font-size: 11pt;
    }
    th, td {
      border: 1px solid #888;
      padding: 8px 10px;
      text-align: center;
    }
    th {
      background: #e8e8e8;
      font-weight: bold;
    }
    td.desc { text-align: left; }

    /* Lottery example */
    .lottery-example {
      font-family: 'Courier New', monospace;
      font-size: 11pt;
      background: #f9f9f9;
      border: 1px solid #ddd;
      padding: 14px 18px;
      margin: 12px 0;
      line-height: 1.8;
    }

    .highlighted {
      color: #c00;
      font-weight: bold;
    }

    /* Privacy bullets */
    ul.privacy-list {
      list-style: disc;
      margin-left: 28px;
    }

    /* Footer */
    .doc-footer {
      margin-top: 40px;
      font-size: 10pt;
      border-top: 1px solid #ccc;
      padding-top: 16px;
      color: #444;
    }

    .page-number {
      text-align: center;
      font-size: 10pt;
      color: #666;
      margin-top: 40px;
    }
`;

export const StyleContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    transition: max-height linear 0.2s;
    align-items: center;
    width: 100%;
    flex-grow: 1;
    padding: 0 12px;
        
    justify-content: space-between;
    > div:last-of-type {
        text-align: center;
         padding-bottom: 12px;
    }
    p{
        color: ${colorToken.white};
        text-align: center;
        padding: 0 16px;
        margin-bottom: 16px;
    }
    @media ${breakpoint.md} {
        /* flex-basis: 50%;
        flex-direction: row; */
        p{
            width: 65%;
            margin: 0 auto 12px;
           
        }
    }

`;

export const StyleTitlePage = styled.h3`
    font-size: 2.2rem;
    color: ${colorToken.color1};
    font-weight: bold;
    text-align: center;
    width: 100%;
    max-width: 950px;
    margin: 0 auto;
    padding-bottom: 16px;
`;

export const StyleRegulamentoWrapper = styled.div`
  background-color: white;
  max-width: 950px;
  margin: 0 auto;
  height: calc(100vh - 230px);
  color: ${colorToken.black};
  padding: 12px;
  font-size: 1.2rem;
  overflow: auto;

  border-radius: 8px;
  border: 2px solid ${colorToken.color1};
  width: 100%;
  h1{
    font-size: 1.6rem;
    font-weight: bold;
  }
  p{
          color: ${colorToken.black};
        text-align: unset;
        padding: 0;
        margin: 0 0 12px;
        width: 100%;
    }
  @media ${breakpoint.md} {
    height: calc(100vh - 220px);
  }
`;

export const StyleRegulamentoContent = styled.div`
  img{
    max-width: 100%;
  }
`;